export const BASE_URL = "https://vybecerkle.com";
export const API_URL =  "https://api.konnxt.com:82"
